"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var pick_1 = __importDefault(require("lodash/pick"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FileInput_1 = __importDefault(require("shared/components/Form/FileInput"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var storage_1 = require("utils/firebase/storage");
var validators_1 = require("utils/form/validators");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var SubmitPopup_1 = __importDefault(require("../SubmitPopup"));
var PREFIX = 'MyCompany';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    item: "".concat(PREFIX, "-item"),
    paper: "".concat(PREFIX, "-paper"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            width: '1000px',
            margin: theme.spacing(0, 'auto', 2, 'auto'),
            padding: theme.spacing(0, 6, 4, 6), // 64 48 32 48
        },
        _b[".".concat(classes.item)] = {
            marginBottom: theme.spacing(2),
        },
        _b[".".concat(classes.paper)] = {
            zIndex: 1,
            position: 'absolute',
            bottom: theme.spacing(4),
            width: '100%',
            borderTop: "1px solid ".concat(theme.palette.secondary.main),
            borderRadius: '0',
            paddingTop: theme.spacing(3),
            '& button[type=submit]': {
                marginRight: theme.spacing(3),
            },
            boxShadow: 'none',
        },
        _b);
});
var MyCompany = function () {
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _a = __read((0, hooks_1.useSubmitter)('companies', profile === null || profile === void 0 ? void 0 : profile.companyId), 1), companySubmitter = _a[0];
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    if (!company) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var initialValues = (0, pick_1.default)(company, ['name', 'employeeCount']);
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var valuesToSave, logoUpdate;
        var logo = _a.logo, employeeCount = _a.employeeCount, values = __rest(_a, ["logo", "employeeCount"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    valuesToSave = __assign({}, values);
                    if (!logo) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, storage_1.uploadCompanyLogo)(company, logo[0], profile.id)];
                case 1:
                    logoUpdate = _b.sent();
                    Object.assign(valuesToSave, logoUpdate);
                    _b.label = 2;
                case 2:
                    valuesToSave.employeeCount = +employeeCount;
                    return [4 /*yield*/, companySubmitter(valuesToSave)];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "My Company", description: "My Company" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, direction: "column", className: classes.wrapper }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.item }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "My company" })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, className: classes.item }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ initialValues: initialValues, onSubmit: onSubmit }, { children: function (_a) {
                                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting, pristine = _a.pristine, form = _a.form, errors = _a.errors;
                                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 3 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "name", color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.required)(), label: "Your company name" }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 3 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "employeeCount", color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.validateNumber)('Please enter a valid size.'), label: "Company size" }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "logo", component: FileInput_1.default, label: "Logo", defaultImage: company.logoUrl, afterSubmit: form.reset }) })), (0, jsx_runtime_1.jsx)(SubmitPopup_1.default, { isOpen: !pristine, onSave: handleSubmit, onCancel: form.reset, formError: Object.keys(errors || {}).length > 0, context: "My Company" })] })));
                                } })) }))] })) }))] }));
};
exports.default = MyCompany;
